export const handleHttpResponse = response => {
  if (!response.ok) {
    throw new Error(`Error fetching data. Status code: ${response.status}`);
  }
  /*
    TODO: Trimet bubbles up their own error messages from time to time 
    and we'll want to grab those inside the `errorMessage` property
  */
  return response.json();
};

/** This is a simple pass through for errors that may have been thrown elsewhere.
 * It gives us an extra layer of handling to work with if we need it for logging, etc
 * This is also our only recourse when an API endpoint does not respond
 *  */
export const handleGlobalError = error => {
  console.error('Error thrown:', error);
  throw error;
};
